<template>
    <div class="register">
        <h1 class="brdBtn topTitle">商品登録</h1>
        <div class="container">
            <div class="infomation">
                <div style="text-align: right;">
                    <span>商品情報取得</span>
                    <input class="input" type="text" v-model="otherSite" placeholder="urlを入力してください">
                    <button class="btn" @click="getSiteInfo" style="
                            width: 10%;
                            height: 1px;
                            font-size: 15px;
                            margin-bottom: 5px;
                            line-height: 1px;">取得</button>
                </div>
                <h2 class="majorItems" :class="{ isOpen: mainIsShow, isClose: !mainIsShow }"
                    @click="mainIsShow = !mainIsShow;">商品の情報</h2>

                <div v-if="mainIsShow">
                    <div class="itemname">
                        <h3 id="itemTitle" class="itemLable">商品名キーワード<span class="mandatory">必須</span></h3>

                        <div class='validErrMsg' v-for="err in $v.postItem.ITEM_TITLE.errMsg" :key="err">{{ err }}</div>

                        <!--
                        <input class="input" id="" type="text" placeholder="商品名、型番など" v-model="postItem.ITEM_TITLE"
                            @input="valid($v.postItem.ITEM_TITLE, '商品名')">
                        <h3 id="itemTitle" class="itemLable">商品名2</h3>
                        <span class="minText">※商品名2を設定すると、出品回数に応じて商品タイトルを入れ替えます。</span>
                        <div class='validErrMsg' v-for="err in $v.postItem.ITEM_TITLE2.errMsg" :key="err">{{ err }}
                        </div>
                        <input class="input" id="" type="text" placeholder="商品名、型番など" v-model="postItem.ITEM_TITLE2"
                            @input="valid($v.postItem.ITEM_TITLE2, '商品名2')">
                        <h3 id="itemTitle" class="itemLable">商品名3</h3>
                        <span class="minText">※商品名3を設定すると、出品回数に応じて商品タイトルを入れ替えます。</span>
                        <div class='validErrMsg' v-for="err in $v.postItem.ITEM_TITLE3.errMsg" :key="err">{{ err }}
                        </div>
                        <input class="input" id="" type="text" placeholder="商品名、型番など" v-model="postItem.ITEM_TITLE3"
                            @input="valid($v.postItem.ITEM_TITLE3, '商品名3')">
                        -->

                        <!-- キーワード入力フォームを10個作成 -->
                        <div v-for="(keyword, index) in keywords" :key="index">
                            <input class="input" type="text" placeholder="キーワードを入力" v-model="keywords[index]"
                                @input="updateItemTitle" :maxlength="getMaxLengthForInput(index)" />
                        </div>

                        <!-- 合計文字数の表示 -->
                        <p>現在の合計文字数: {{ totalLength }} / 40</p>

                        <!-- エラーメッセージ -->
                        <div class='validErrMsg' v-if="totalLength > 40">キーワードの合計文字数は40文字までです。</div>
                    </div>
                    <div class="brdBtm">
                        <h3 class="itemLable">画像</h3>
                        <div class="paddingBtm30">
                            <div v-if="tmpFiles.length > 0">
                                <span class="minText">※チェックをつけた画像は出品毎に画像表示を入れ替えます。</span><br>
                                <!-- <div class="imagePrevBox" > -->
                                <draggable class="imagePrevBox" v-bind="{ animation: 200 }" @end="onEnd"
                                    v-model="tmpFiles">
                                    <div v-for="(tmpFile, index) in tmpFiles" :key="index">
                                        <div>
                                            <div class="childImgBox">
                                                <img class="itemImg" :src="tmpFile">
                                                <input type="checkbox"
                                                    :disabled="tmpRoopImg.length >= 3 && tmpRoopImg.indexOf(String(index + 1)) == -1"
                                                    v-model="tmpRoopImg" :id="index + 1" :value="String(index + 1)">
                                                <label class="checkbox03" :for="index + 1"></label>
                                                <span class="delBtn" @click="fileDelete(index)"></span>
                                                <span class="drive" @click="getDriveImg(false)"></span>
                                            </div>
                                            <div style="text-align: center;">
                                                <button class="btn" style="width: 90%;font-size: 10px;"
                                                    @click="test(tmpFile)">プレビュー</button>
                                            </div>

                                        </div>

                                    </div>
                                    <div class="childImgBox setImgBox" v-if="tmpFiles.length < 10"
                                        style="height: 100px;margin: 5px;">
                                        <!-- <button class="btn" @click="getDriveImg(false)">GoogleDrive<br>から選択</button> -->
                                        <input class="files" type="file" title @change="onChange">
                                        <span class="minText centerText">あと{{ 10 - tmpFiles.length
                                            }}枚<br>登録できます</span>
                                    </div>
                                </draggable>
                                <!-- </div> -->
                            </div>
                            <div class="image-input" v-if="tmpFiles.length == 0">
                                <div class="image-input__field" @dragover.prevent="onDrag('over')">
                                    <input class="files" type="file" title multiple @change="onChange">
                                    <p class="imgText">ドラッグ&ドロップ</P>
                                    <label class="imgBtn">
                                        ファイルを<br>選択
                                        <input class="none" type="file" multiple @change="onChange">
                                    </label>
                                    <!-- <label class="imgBtn" @click="getDriveImg">GoogleDrive<br>から選択</label> -->
                                </div>
                            </div>
                        </div>

                        <div id="overlay" v-show="isDriveErr">
                            <div class="driveModal">
                                <div class="swal2-popup swal2-modal swal2-show" style="display: grid;">
                                    <p>フォルダ内の画像が多すぎます。不要な画像を削除してください</p>
                                    <div class="imagePrevBox">
                                        <div class="childImgBox" v-for="(item, index) in tmpGogoleImg" :key="index">
                                            <img class="itemImg" :src="item">
                                            <span class="delBtn" @click="driveFileDelete(index - 1)"></span>
                                        </div>
                                    </div>
                                    <button class="swal2-confirm swal2-styled" @click="setDriveInFile"
                                        :disabled="(tmpGogoleImg.length + tmpFiles.length) > 10">Close</button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="brdBtm">
                        <h3 id="itemContent" class="itemLable">商品説明<span class="mandatory">必須</span></h3>

                        <div class='validErrMsg' v-for="(err) in $v.postItem.ITEM_CONTENT.errMsg" :key="err">{{ err
                            }}
                        </div>

                        <textarea rows="10" cols="100" class="txtarea" placeholder="商品の特徴や、使用感、魅力など"
                            v-model="postItem.ITEM_CONTENT" @input="valid($v.postItem.ITEM_CONTENT, '商品説明')"></textarea>
                    </div>

                    <div class="brdBtm">
                        <h3 id="status" class="itemLable">商品状態<span class="mandatory">必須</span></h3>

                        <div class='validErrMsg' v-for="(err) in $v.tmpStatus.errMsg" :key="err">{{ err }}</div>

                        <select class="sltBox" v-model="tmpStatus" @change="valid($v.tmpStatus, '商品状態')">
                            <option value="" disabled selected hidden>選択してください</option>
                            <option v-for="item in statusList" :value="item.CODE_ID" :key="item.ITEM_ID">
                                {{ item.CODE_NAME }}
                            </option>
                        </select>
                    </div>
                    <div class="brdBtm">
                        <h3 id="itemPrice" class="itemLable">商品販売価格<span class="mandatory">必須</span></h3>

                        <div class='validErrMsg' v-for="(err) in $v.postItem.ITEM_PRICE.errMsg" :key="err">{{ err }}
                        </div>

                        <input class="input-2" type="number" v-model="postItem.ITEM_PRICE"
                            @input="valid($v.postItem.ITEM_PRICE, '商品販売価格')">
                        <p class="unit">円</p>
                    </div>

                    <div class="brdBtm">
                        <h3 id="purchasePrice" class="itemLable">商品仕入価格</h3>
                        <div class='validErrMsg' v-for="(err) in $v.postItem.PURCHASE_PRICE.errMsg" :key="err">{{
                            err }}
                        </div>

                        <input class="input-2" type="number" v-model="postItem.PURCHASE_PRICE"
                            @input="valid($v.postItem.PURCHASE_PRICE, '商品仕入価格')">
                        <p class="unit">円</p>
                    </div>
                    <div class="brdBtm">
                        <h3 id="quanity" class="itemLable">在庫数<span class="mandatory">必須</span></h3>

                        <div class='validErrMsg' v-for="(err) in $v.postItem.STOCK_QUANITY.errMsg" :key="err">{{ err
                            }}
                        </div>

                        <input class="input-2" type="number" v-model="postItem.STOCK_QUANITY"
                            @input="valid($v.postItem.STOCK_QUANITY, '在庫数')">
                        <p class="unit">個</p>
                    </div>
                    <div class="brdBtm">
                        <h3 id="discountPrice" class="itemLable">値引額</h3>
                        <div class='validErrMsg' v-for="(err) in $v.postItem.DISCOUNT_PRICE.errMsg" :key="err">{{
                            err }}
                        </div>
                        <div class="minText">※未入力の場合、販売開始から値引をいたしません。</div>
                        <input class="input-2" type="number" v-model="postItem.DISCOUNT_PRICE"
                            @input="valid($v.postItem.DISCOUNT_PRICE, '値引額')">
                        <p class="unit">円</p>
                    </div>


                    <!--
                    <div id="discountNum" class="brdBtm" v-show="postItem.DISCOUNT_PRICE != 0">
                        <h3 class="itemLable">値引回数</h3>
                        <div class='validErrMsg' v-for="(err) in $v.postItem.DISCOUNT_NUM.errMsg" :key="err">{{ err
                            }}
                        </div>
                        <div class="minText">※値引額を入力した場合は必須項目です。</div>
                        <input class="input-2" type="number" v-model="postItem.DISCOUNT_NUM"
                            @input="valid($v.postItem.DISCOUNT_NUM, '値引回数')">
                        <p class="unit">回</p>
                    </div>
               
                    
                    <div>
                        <h3 class="itemLable">出品停止日</h3>
                        <span class="minText">出品日時から選択日後に出品停止します。</span>
                        <select class="sltBox" v-model="postItem.SUSPEND_DAY">
                            <option :value="1">1日後</option>
                            <option :value="2">2日後</option>
                            <option :value="3">3日後</option>
                            <option :value="4">4日後</option>
                        </select>
                    </div>

                    -->

                    <div class="brdBtm">
                        <h3 id="shipLoad" class="itemLable">いいねがついた商品に自動コメントをする<span class="mandatory">必須</span>
                        </h3>

                        <!-- <div class='validErrMsg' v-for="(err) in $v.tmpShipload.errMsg" :key="err">{{ err }}</div> -->

                        <span v-for="n in 2" :key="n">
                            <input type="radio" v-model="postItem.COMMENT" :id="n + '_suspendList'" :value="n">
                            <label class="radioLabel" :for="n + '_suspendList'">{{ n == 1 ? 'コメントする' : 'コメントしない'
                                }}</label>
                        </span>
                    </div>

                <!--
                    <div class="brdBtm">
                        <h3 id="shipLoad" class="itemLable">複数出品する</h3>

                        <div class='validErrMsg' v-for="(err) in $v.tmpShipload.errMsg" :key="err">{{ err }}</div> 

                        <span v-for="n in 2" :key="n">
                            <input type="radio" v-model="m_postItem.MULTIPLE_SELL" :id="n + 'multiple_sell'" :value="n">
                            <label class="radioLabel" :for="n + 'multiple_sell'">{{ n == 1 ? '複数出品する' : '複数出品しない'
                                }}</label>
                        </span>
                    </div>
                -->


                    <div class="brdBtm">
                        <h3 id="shipLoad" class="itemLable">送料負担<span class="mandatory">必須</span></h3>

                        <div class='validErrMsg' v-for="(err) in $v.tmpShipload.errMsg" :key="err">{{ err }}</div>

                        <span v-for="item in shiploadList" :key="item.CODE_ID">
                            <input type="radio" v-model="tmpShipload" :id="item.CODE_ID + '_shiploadList'"
                                :value="item.CODE_ID" @change="valid($v.tmpShipload, '送料負担')">
                            <label class="radioLabel" :for="item.CODE_ID + '_shiploadList'">{{ item.CODE_NAME
                                }}</label>
                        </span>
                    </div>
                    <div class="brdBtm">
                        <h3 id="shipSorce" class="itemLable">発送元<span class="mandatory">必須</span></h3>

                        <div class='validErrMsg' v-for="(err) in $v.tmpShipsource.errMsg" :key="err">{{ err }}</div>

                        <select class="sltBox" v-model="tmpShipsource" @change="valid($v.tmpShipsource, '発送元')">
                            <option value="" disabled selected hidden>選択してください</option>
                            <option v-for="item in shipsorceList" :value="item.CODE_ID" :key="item.CODE_ID">
                                {{ item.CODE_NAME }}
                            </option>
                        </select>
                    </div>
                    <div class="brdBtm">
                        <h3 id="shipSchedule" class="itemLable">発送日数<span class="mandatory">必須</span></h3>

                        <div class='validErrMsg' v-for="(err) in $v.tmpShipSchedule.errMsg" :key="err">{{ err }}
                        </div>

                        <select class="sltBox" v-model="tmpShipSchedule" @change="valid($v.tmpShipSchedule, '発送日数')">
                            <option value="" disabled selected hidden>選択してください</option>
                            <option v-for="item in shipScheduleList" :value="item.CODE_ID" :key="item.CODE_ID">
                                {{ item.CODE_NAME }}
                            </option>
                        </select>
                    </div>
                    <div class="brdBtm">

                        <h3 id="shipSchedule" class="itemLable">備考</h3>
                        <span class="minText">出品には影響ありません。ご自身のメモ用に記載ください</span>
                        <textarea rows="10" cols="100" class="txtarea" placeholder="備考"
                            v-model="postItem.MEMO"></textarea>
                    </div>
                </div>




                <!-- メルカリ用ボックス -->
                <div class="MercariItem">
                    <h2 class="majorItems" :class="{ isOpen: mercariIsShow, isClose: !mercariIsShow }"
                        @click="mercariIsShow = !mercariIsShow;">メルカリ独自設定</h2>
                    <div v-if="mercariIsShow">
                        <div class="brdBtm">
                            <h3 id="mcategory" class="itemLable">カテゴリ<span class="mandatory">必須</span></h3>

                            <div class="s" v-for="(child, index) in mCategoryList.child" :key="index">

                                <div class='validErrMsg'
                                    v-for="(err) in $v.mCategoryList.child.$each[index].parentId.errMsg" :key="err">
                                    {{
                                        err }}</div>

                                <select class="sltBox" v-model="mCategoryList.child[index].parentId"
                                    @change="
                                        MercarSizeCheck(mCategoryList.child[index].parentId), MercarBrandCheck(mCategoryList.child[index].parentId), getChildCategory('n', 'mCategoryList', index), valid($v.mCategoryList.child.$each[index].parentId, 'カテゴリ')">
                                    <option value="" disabled selected hidden>選択してください</option>
                                    <option v-for="item in mCategoryList.child[index].parent" :value="item.CODE_ID"
                                        :key="item.CODE_ID">
                                        {{ item.CODE_NAME }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="brdBtm" v-show="MSizeList.length > 0">
                            <h3 id="mSize" class="itemLable">サイズ<span class="mandatory">必須</span></h3>
                            <div class='validErrMsg' v-for="(err) in $v.postItem.M_SIZE.errMsg" :key="err">{{ err }}
                            </div>
                            <select class="sltBox" v-model="postItem.M_SIZE" @change="valid($v.postItem.M_SIZE, 'サイズ')">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in MSizeList" :value="item.CODE_ID" :key="item.CODE_ID">
                                    {{ item.CODE_NAME }}
                                </option>
                            </select>
                        </div>

                        <div class="brdBtm" v-show="isBrand" style="width: 90%;">
                            <h3 id="mbrand" class="itemLable">ブランド</h3>
                            <vselect label="CODE_NAME" :reduce="item => item.CODE_ID" :options="tmpBrandList"
                                v-model="m_postItem.M_BRAND" placeholder="ブランド名を入力してください" :filter="selectFilter"
                                @input="inputFilter">
                                <template v-slot:no-options>候補がありません</template>
                            </vselect>
                        </div>
                        <div class="brdBtm">
                            <h3 id="mShipMethod" class="itemLable">配送方法<span class="mandatory">必須</span></h3>

                            <div class='validErrMsg' v-for="(err) in $v.postItem.M_SHIPMETHOD.errMsg" :key="err">{{
                                err
                            }}</div>

                            <select class="sltBox" v-model="postItem.M_SHIPMETHOD"
                                @change="valid($v.postItem.M_SHIPMETHOD, '配送方法')">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in MShipMethodList" :value="item.CODE_ID" :key="item.CODE_ID">
                                    {{ item.CODE_NAME }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <!-- モーダルStr -->
                <div class="overlay" v-show="showModal">
                    <div class="createModal" style="height: 80%;">
                        <div class="swal2-popup swal2-modal swal2-show" style="display: grid;height: 100%;">
                            <div class="login" style="background-color: #fff;">
                                <div style="margin: 10px;text-align: center;">
                                    <img :src="tmpBase64" style="width: 100%;">
                                    <div class="">
                                        <button class="btn repage" @click="showModal = !showModal">
                                            閉じる
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- モーダルEnd -->
                <div class="none">
                    <input type="text" v-model="tmp">
                </div>
                <div class="btnBox">
                    <button class="btn repage" @click="returnPage">戻る</button>
                    <button class="btn submit" v-show="ITEM_ID != 0" @click="post(true)">コピー</button>
                    <button class="btn submit" @click="post(false)">登録</button>
                </div>
                <!-- <div class="PaypayItem">
                    <h2 class="majorItems">PayPayフリマ独自設定</h2>
                </div> -->
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
@import "../style/register.scss";
</style>
<script>
import { codeRepository } from '@/Repositories/codeRepository.js'
import { categoryRepository } from '@/Repositories/categoryRepository.js'
import { itemRepository } from '@/Repositories/itemRepository.js'
import { cApiRepsitory } from '@/Repositories/cApiRepsitory.js'
import { otherSiteRepsitory } from '@/Repositories/otherSiteRepsitory.js'

import check from '@/common/commonCheck';
import { required, maxLength, between, minValue, helpers } from "vuelidate/lib/validators";
import axios from 'axios';
import draggable from 'vuedraggable'
import vselect from 'vue-select'
var gasUrl = "https://script.google.com/macros/s/AKfycbyOcPBQiZtl3yGMo1iMmeCTgtblLg1Kg3sf7foUC0xAW2L3Zhg/exec";
export default {
    components: { draggable, vselect },
    data() {
        return {
            check: check,
            options: {
                animation: 200
            },
            perPage: 20,
            currentPage: 1,
            rows: 6,
            now_select: '',
            now_filter: '',
            /******************
             表示・非表示フラグ
            ******************/
            mainIsShow: true,
            mercariIsShow: false,
            // rakumaIsShow:false,
            // yahooIsShow:false,
            // yPremierIsShow:false,
            isDriveErr: false,
            isBrand: false,
            showModal: false,
            /******************
             カテゴリリスト
            ******************/
            baseCategories: null,
            mCategoryList: {
                parentId: '',
                parent: [],
                child: [{ parentId: '' }]
            },
            //     rCategoryList:{
            //        parentId:'',
            //        parent:[],
            //        child:[{parentId:''}]
            //    },
            //     yCategoryList:{
            //        parentId:'',
            //        parent:[],
            //        child:[{parentId:''}]
            //    },
            /******************
             コードリスト
             （共通）
            ******************/
            baseCode: null,
            statusList: null,
            shiploadList: null,
            shipsorceList: null,
            shipScheduleList: null,
            /******************
             コードリスト
             （メルカリ独自）
            ******************/
            MSizeList: [],
            MSizeList1: null,
            MSizeList2: null,
            MSizeList3: null,
            MSizeList4: null,
            MSizeList5: null,
            MSizeList6: null,
            MSizeList7: null,
            MSizeList8: null,
            MSizeList9: null,
            MSizeList10: null,
            MSizeList11: null,
            MSizeList12: null,
            MShipMethodList: null,
            MBrandList: [],
            /******************
             一時選択値格納
            ******************/
            tmp: '',
            tmpStatus: '',
            tmpShipload: '',
            tmpShipsource: '',
            tmpShipSchedule: '',
            tmpBrandList: [{ CODE_NAME: "ブランド名を入力してください", CODE_ID: 0 }],
            tmpRoopImg: [],
            tmpFiles: [],
            tmpGogoleImg: [],
            tmpYOptions: [],
            ITEM_ID: 0,
            otherSite: '',
            tmpBase64: '',
            /******************
             サーバサイド連携値
            ******************/
            m_postItem: {
                type: 'mercari_item_detail',
                MULTIPLE_SELL: 2
            },
            totalLength: 0, // キーワードの合計文字数
            keywords: Array(10).fill(''),  // 10個の空のキーワードフィールドを用意
            postItem: {
                ITEM_TITLE: '',
                ITEM_TITLE2: '',
                ITEM_TITLE3: '',
                ITEM_CONTENT: '',
                ITEM_IMG1: '',
                ITEM_IMG2: '',
                ITEM_IMG3: '',
                ITEM_IMG4: '',
                ITEM_IMG5: '',
                ITEM_IMG6: '',
                ITEM_IMG7: '',
                ITEM_IMG8: '',
                ITEM_IMG9: '',
                ITEM_IMG10: '',
                ROOP_IMG: '',
                ITEM_PRICE: '0',
                PURCHASE_PRICE: '0',
                STOCK_QUANITY: '0',
                DISCOUNT_PRICE: 0,
                DISCOUNT_NUM: 0,
                SUSPEND_DAY: 4,
                MEMO: null,
                // Y_STATUS:'',
                // Y_CATEGORY:'',
                // Y_MAKER:'',
                // Y_SERIES:'',
                // Y_SIZE:'',
                // Y_SIZE2:'',
                // Y_QUANTITY:1,
                // Y_SHIPSOURCE:'',
                // Y_SHIPLOAD:'',
                // Y_SHIPMETHOD1:'',
                // Y_SHIPMETHOD2:'',
                // Y_SHIPMETHOD3:'',
                // Y_SHIPMETHOD4:'',
                // Y_SHIPMETHOD5:'',
                // Y_SHIPMETHOD6:'',
                // Y_SHIPMETHOD7:'',
                // Y_SHIPMETHOD8:'',
                // Y_SHIPMETHOD9:'',
                // Y_SHIPMETHOD10:'',
                // Y_SHIPMETHODOTHER1:'',
                // Y_SHIPMETHODOTHER2:'',
                // Y_SHIPMETHODOTHER3:'',
                // Y_SHIPMETHODOTHER4:'',
                // Y_SHIPMETHODOTHER5:'',
                // Y_SHIPMETHODOTHER6:'',
                // Y_SHIPMETHODOTHER7:'',
                // Y_SHIPMETHODOTHER8:'',
                // Y_SHIPMETHODOTHER9:'',
                // Y_SHIPMETHODOTHER10:'',
                // Y_SHIPSCHEDULE:'',
                // Y_SALESMODE:'buynow',
                // Y_STARTPRICE:0,
                // Y_ENDDAY:'',
                // Y_ENDTIME:'',
                // Y_NUMRESUBMIT:'',
                // Y_AUTOPRICEDOWN:'',
                // Y_CATEGORYORDER:'',
                // Y_CPAAMOUNT:'',
                // Y_OPTIONS:[],
                M_CATEGORY: '',
                M_BRAND: '',
                M_SIZE: '',
                M_SHIPLOAD: '',
                M_SHIPMETHOD: '',
                M_SHIPSOURCE: '',
                M_SHIPSCHEDULE: '',
                M_STATUS: '',
                // R_CATEGORY:'',
                // R_BRAND:'',
                // R_SIZE:'',
                // R_SHIPLOAD:'',
                // R_SHIPMETHOD:'',
                // R_SHIPSCHEDULE:'',
                // R_SHIPSOURCE:'',
                // R_REQUEST_REQUIRED:0,
                // R_STATUS:''
            }
        };
    },
    mounted() {
        this.updateTotalLength(); // 初期合計文字数の計算
    },
    watch: {
        // ITEM_TITLEの変更を監視して、keywordsを更新する
        'postItem.ITEM_TITLE'(newVal) {
            this.updateKeywordsFromItemTitle(newVal);
        }
    },
    methods: {
        // キーワードの合計文字数を更新
        updateTotalLength() {
            this.totalLength = this.keywords.reduce((acc, keyword) => acc + keyword.length, 0);
        },

        // ITEM_TITLEをキーワードに変換してkeywordsを更新
        updateKeywordsFromItemTitle(itemTitle) {
            const itemTitleKeywords = itemTitle.split(/\s+/).map(keyword => keyword.trim());
            this.keywords = [...itemTitleKeywords, ...Array(10 - itemTitleKeywords.length).fill('')].slice(0, 10);
            this.updateTotalLength();  // 合計文字数も更新
        },

        // キーワードが変更されたときにITEM_TITLEを更新
        updateItemTitle() {
            // キーワードをスペースで結合してITEM_TITLEに保存
            this.postItem.ITEM_TITLE = this.keywords.filter(k => k.trim() !== '').join(' ').slice(0, 40);
            this.updateTotalLength();  // 合計文字数も更新
        },

        // 各入力欄の最大文字数を動的に設定
        getMaxLengthForInput(index) {
            const currentLength = this.keywords[index].length;
            const remainingChars = 40 - (this.totalLength - currentLength);
            return Math.min(remainingChars, 40);
        },
        onEnd(e) {
            this.tmpRoopImg.sort()
            var oldIndex = e.oldDraggableIndex + 1;
            var newindex = e.newIndex + 1;
            var index = this.tmpRoopImg.indexOf(String(oldIndex));
            if (index != -1) {
                this.tmpRoopImg[index] = String(newindex);
            }
            for (var i = 0; i < this.tmpRoopImg.length; i++) {
                if (i == index) continue;
                if (newindex <= this.tmpRoopImg[i] && oldIndex > this.tmpRoopImg[i]) {
                    var id = Number(this.tmpRoopImg[i]) + 1;
                    this.tmpRoopImg[i] = String(id);
                }
            }

            for (var i = 0; i < this.tmpRoopImg.length; i++) {
                if (i == index) continue;
                if (newindex >= this.tmpRoopImg[i] && oldIndex < this.tmpRoopImg[i]) {
                    var id = Number(this.tmpRoopImg[i]) - 1;
                    this.tmpRoopImg[i] = String(id);
                }
            }
        },
        MercarSizeCheck(str) {
            let vm = this;
            // vm.postItem.M_SIZE = "";
            vm.MSizeList = [];
            for (var i = 1; i <= 12; i++) {
                var c = eval(`vm.MSizeList${i}[0].PARENT_ID.split(",");`)
                if (c.indexOf(str) != -1) {
                    vm.MSizeList = eval(`vm.MSizeList${i}`);
                }
            }
        },
        MercarBrandCheck(str) {
            let vm = this;
            console.log(str);
            var code = vm.baseCategories.find(x => x.SITE_TYPE == 'n' && x.CODE_ID == str);

            console.log(code);
            vm.isBrand = code.IS_SHOW_BRAND != null;

        },
        resizeImage(base64image) {
            const MIN_SIZE = 1000;
            return new Promise(async function (resolve, reject) {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                var image = new Image();
                image.crossOrigin = "Anonymous";
                image.onload = function (event) {
                    var dstWidth, dstHeight;
                    if (this.width <= MIN_SIZE && this.height <= MIN_SIZE) {
                        dstWidth = this.width;
                        dstHeight = this.height;
                    } else {
                        if (this.width > this.height) {
                            dstWidth = MIN_SIZE;
                            dstHeight = this.height * MIN_SIZE / this.width;
                        } else {
                            dstHeight = MIN_SIZE;
                            dstWidth = this.width * MIN_SIZE / this.height;
                        }
                    }
                    canvas.width = dstWidth;
                    canvas.height = dstHeight;
                    ctx.drawImage(this, 0, 0, this.width, this.height, 0, 0, dstWidth, dstHeight);
                    var dataURI = canvas.toDataURL('image/jpeg');
                    resolve(dataURI);
                };
                image.src = base64image;

            })
        },
        GetCode(siteType, codeType) {
            let vm = this;
            var rtnItem = vm.baseCode.filter((item) => {
                return item.SITE_TYPE == siteType && item.CODE_TYPE == codeType;
            });
            return rtnItem.sort((a, b) => {
                return a.CODE_ID - b.CODE_ID
            });
        },
        GetRadioText(val) {
            let vm = this;
            var text = vm.YOptionsTextList.filter((item) => {
                return item.CODE_ID == val;
            });
            return text[0].CODE_NAME;
        },
        GetCategories(siteType, parentId) {
            let vm = this;
            var rtnItem = vm.baseCategories.filter((item) => {
                return item.SITE_TYPE == siteType && item.PARENT_ID == parentId;
            });
            return rtnItem.sort((a, b) => {
                return a.CODE_ID - b.CODE_ID
            });
        },
        getChildCategory(siteType, valName, index) {
            let vm = this;
            var tmp = {}
            tmp.parent = vm.GetCategories(siteType, eval(`vm.${valName}.child[${index}].parentId`));
            tmp.child = [];
            tmp.parentId = '';

            eval(`vm.${valName}.child.splice(${index} + 1);`)

            if (tmp.parent.length > 0) eval(`vm.${valName}.child.push(tmp);`);

        },


        onDrag(type) {
            this.isDragOver = type === "over";
        },
        onChange(event) {
            const files = event.target.files;
            if (files.length === 0) return;
            var tmpFiles = [];

            if (files.length > 10) {
                this.ngAlert("画像は最大10枚までです。<br>11枚目以降は無視されます。")
            }

            for (var i = 0; i < files.length; i++) {
                if (files[i].type.match(/image/)) {
                    tmpFiles.push(files[i]);
                }
            }
            if (tmpFiles.length == 0) return;

            this.readImage(tmpFiles);
        },
        readImage(files) {
            for (var i = 0; i < files.length; i++) {
                if (i >= 10) return;
                let reader = new FileReader();
                reader.onload = this.loadImage;
                reader.readAsDataURL(files[i]);
            }
        },
        loadImage(e) {
            let image = new Image();
            image.src = e.target.result;
            this.tmpFiles.push(image.src);
        },
        /**
         * 表示している画像を削除します。
         * @param {number}} index 配列Index
         */
        fileDelete(index) {
            this.tmpFiles.splice(index, 1);
            this.tmpRoopImg.sort()
            var arrIndex = this.tmpRoopImg.indexOf(index + 1);

            if (arrIndex != -1)
                this.tmpRoopImg.splice(arrIndex, 1);

            for (var i = 0; i < this.tmpRoopImg.length; i++) {
                if (this.tmpRoopImg[i] > index + 1) this.tmpRoopImg[i] = (this.tmpRoopImg[i] - 1).toString();
            }
            console.log(this.tmpRoopImg);
            this.tmpRoopImg = this.tmpRoopImg.filter((element, index) => this.tmpRoopImg.indexOf(element) == index);
            console.log(this.tmpRoopImg);
        },
        /**
         * GoogleDriveの画像からBase64を取得します。
         * @param {boolean} isMulti 複数取得可否
         */
        async getDriveImg() {

            var inputText = `<h4>フォルダの共有リンクを入力</h4><span class="minText">※共有設定は必ず、<br>【リンクを知っている全員（閲覧者）】<br>に設定してください。</span><label>共有リンク:<input id="swal-input1" class="swal2-input" placeholder="共有リンク"></label>`;
            const { value: formValues } = await this.$swal.fire({
                title: 'GoogleDriveから画像設定',
                html: inputText,
                focusConfirm: false,
                preConfirm: () => {
                    return document.getElementById('swal-input1').value;
                }
            })
            if (formValues) {

                var url = formValues;
                if (!url) return;
                this.driveImgToBase64(url)
            }
        },
        /**
         * GoogleDriveへGetリクエストを投げます
         * @param {string}} url GoogleDrive画像URL
         */
        driveImgToBase64(url) {
            let vm = this;
            var api = `${gasUrl}?imgUrl=${url}`;
            axios.get(api)
                .then(res => {
                    vm.tmpGogoleImg = res.data.base64;

                    if (vm.tmpGogoleImg.length > 10) {
                        this.isDriveErr = true;
                    } else
                        this.tmpFiles = imgList

                }).catch(err => {
                    console.log(err);
                })
        },
        driveFileDelete(index) {
            this.tmpGogoleImg.splice(index + 1, 1);
        },
        setDriveInFile() {
            let vm = this;
            vm.isDriveErr = false;
            vm.tmpFiles = vm.tmpFiles.concat(vm.tmpGogoleImg);
        },
        /**
         * 遷移元へ戻ります
         */
        returnPage() {
            let vm = this;
            vm.$router.back();
        },
        /**
         * サーバサイドへポスト送信
         */
        async post(isCopy) {
            let vm = this;
            vm.mainIsShow = true;
            vm.mercariIsShow = true;
            // vm.rakumaIsShow=true;
            // vm.yahooIsShow=true;
            // vm.yPremierIsShow=true;
            if (!vm.validAll()) {
                vm.tmp = 'tmp';
                vm.tmp = '';
                return;
            }

            //統一項目を各々のEntityに詰めなおす
            vm.setStatus();
            vm.setShipLoad();
            vm.setShipSchedule();
            vm.setShipsource();
            vm.setCategory('m');
            // vm.setCategory('r');
            // vm.setCategory('y');
            await vm.setBase64();
            // vm.postItem.Y_OPTIONS = vm.tmpYOptions.join(',');
            vm.postItem.ROOP_IMG = vm.tmpRoopImg.sort().join(',');
            if (isCopy) vm.postItem.ITEM_ID = null;

            itemRepository.methods.register(vm.postItem)
                .then(res => {
                    vm.m_postItem.ITEM_ID = res.data.ITEM_ID;
                    cApiRepsitory.methods.post(vm.m_postItem).then(res => {
                        this.$swal("登録が完了しました", {
                            icon: "success",
                        }).then(() => {
                            vm.$router.push(`/itemList/${vm.$route.params.pageNum}`);
                        })
                    })
                }).catch(err => {
                    console.log(err);
                })
        },
        /**
         * 単体バリデーションチェックを実行し、エラーメッセージを設定します
         * @param {object} v validationオブジェクト
         * @param {stirng} name バリデーションエラーメッセージに表示する項目名
         * @param {stirng} regexType 正規表現種別
         */
        valid(v, name, regexType) {
            check.checkStr(v, name, regexType);
        },
        /**
         * 全てのバリデーションチェックを実行し、エラーメッセージを設定します
         */
        validAll() {
            let vm = this;
            var isError = false;
            try {
                if (!check.checkStr(vm.$v.postItem.ITEM_TITLE, '商品名')) throw 'itemTitle';
                if (!check.checkStr(vm.$v.postItem.ITEM_CONTENT, '商品説明')) throw 'itemContent';

                if (!check.checkStr(vm.$v.postItem.ITEM_TITLE, '商品名')) throw 'itemTitle';
                if (!check.checkStr(vm.$v.tmpStatus, '商品状態')) throw 'status';
                if (!check.checkStr(vm.$v.postItem.ITEM_PRICE, '商品販売価格')) throw 'itemPrice';
                if (!check.checkStr(vm.$v.postItem.PURCHASE_PRICE, '商品仕入価格')) throw 'purchasePrice';
                if (!check.checkStr(vm.$v.postItem.STOCK_QUANITY, '在庫数')) throw 'quanity';
                if (!check.checkStr(vm.$v.postItem.DISCOUNT_PRICE, '値引額')) throw 'discountPrice';
                if (!check.checkStr(vm.$v.postItem.DISCOUNT_NUM, '値引回数')) throw 'discountNum';

                if (!check.checkStr(vm.$v.tmpShipload, '送料負担')) throw 'shipLoad';
                if (!check.checkStr(vm.$v.tmpShipsource, '発送元')) throw 'shipSorce';
                if (!check.checkStr(vm.$v.tmpShipSchedule, '発送日数')) throw 'shipSchedule';


                for (var i = 0; i < vm.mCategoryList.child.length; i++) {
                    if (!check.checkStr(vm.$v.mCategoryList.child.$each[i].parentId, 'カテゴリ')) throw 'mcategory';
                }
                // for(var i =0; i<vm.rCategoryList.child.length; i++){
                //     if(!check.checkStr(vm.$v.rCategoryList.child.$each[i].parentId, 'カテゴリ')) throw 'rcategory';
                // }
                // for(var i =0; i<vm.yCategoryList.child.length; i++){
                //     if(!check.checkStr(vm.$v.yCategoryList.child.$each[i].parentId, 'カテゴリ')) throw 'ycategory';
                // }
                if (!check.checkStr(vm.$v.postItem.M_SHIPMETHOD, '配送方法')) throw 'mShipMethod';
                // if(!check.checkStr(vm.$v.postItem.R_SHIPMETHOD, '配送方法')) throw 'rShipMethod';
                if (vm.MSizeList.length > 0) {
                    if (!check.checkStr(vm.$v.postItem.M_SIZE, 'サイズ')) throw 'mSize';
                }
                // if(vm.RSizeList.length > 0){
                //     if(!check.checkStr(vm.$v.postItem.R_SIZE, 'サイズ')) throw 'rSize';
                // }
                // if(!check.checkStr(vm.$v.postItem.Y_QUANTITY, '個数')) throw 'yQuantity';
                // if(!check.checkStr(vm.$v.postItem.Y_ENDDAY, '終了する日')) throw 'endDay';
                // if(!check.checkStr(vm.$v.postItem.Y_ENDTIME, '終了する時間')) throw 'endTime';
            } catch (e) {
                vm.$scrollTo(`#${e}`, { duration: 1000, offset: -100 })
                return false;
            }
            return true;
        },
        setCategory(siteType) {
            let vm = this;
            var category = '';
            for (var i = 0; i < eval(`vm.${siteType}CategoryList.child.length`); i++) {
                if (!eval(`vm.${siteType}CategoryList.child[${i}].parentId`)) continue;
                category += eval(`vm.${siteType}CategoryList.child[${i}].parentId`) + ',';

            }
            siteType = siteType.toUpperCase();
            eval(`vm.postItem.${siteType}_CATEGORY = '${category}'`);
        },
        /**
         * 共通画像設定をEntityにセットする
         */
        async setBase64() {
            let vm = this;
            for (var i = 1; i <= 10; i++) {
                if (!vm.tmpFiles[i - 1]) {
                    eval(`vm.postItem.ITEM_IMG${i} = null`);
                } else {
                    var base64 = await vm.resizeImage(vm.tmpFiles[i - 1]);
                    eval(`vm.postItem.ITEM_IMG${i} = '${base64}'`);
                }

            }
        },
        /**
         * 共通発送元設定から、各サイト用発送元コードに変換、Entityにセットする
         */
        setShipsource() {
            let vm = this;
            var m = vm.shipsorceList.filter((item) => {
                return item.CODE_ID == vm.tmpShipsource;
            });
            // var r = vm.RShipsorceList.filter((item)=> {
            //     return item.CODE_NAME == m[0].CODE_NAME;
            // });
            // var y = vm.YShipsorceList.filter((item)=> {
            //     return item.CODE_NAME == m[0].CODE_NAME;
            // });

            // if(r.length == 0)r[0].CODE_ID = '';
            // if(y.length == 0) y[0].CODE_ID = '48';

            vm.postItem.M_SHIPSOURCE = m[0].CODE_ID;
            // vm.postItem.R_SHIPSOURCE = r[0].CODE_ID;
            // vm.postItem.Y_SHIPSOURCE = y[0].CODE_ID;
        },
        /**
         * 共通発送日程設定から、各サイト用発送日程コードに変換、Entityにセットする
         */
        setShipSchedule() {
            let vm = this;
            var tmpShipSchedule = {};
            switch (vm.tmpShipSchedule) {
                case '1':
                    tmpShipSchedule.y = '1'
                    tmpShipSchedule.r = '1'
                    break;
                case '2':
                    tmpShipSchedule.y = '7'
                    tmpShipSchedule.r = '2'
                    break;
                case '3':
                    tmpShipSchedule.y = '2'
                    tmpShipSchedule.r = '3'
                    break;
            }
            vm.postItem.M_SHIPSCHEDULE = vm.tmpShipSchedule;
            vm.postItem.R_SHIPSCHEDULE = tmpShipSchedule.r;
            vm.postItem.Y_SHIPSCHEDULE = tmpShipSchedule.y;
        },
        /**
         * 共通送料負担設定から、各サイト用送料負担スコードに変換、Entityにセットする
         */
        setShipLoad() {
            let vm = this;
            var tmpShipLoad = {};
            switch (vm.tmpShipload) {
                case '1':
                    tmpShipLoad.m = '1';
                    tmpShipLoad.y = 'buyer';
                    tmpShipLoad.r = '2';
                    break;
                case '2':
                    tmpShipLoad.m = '2';
                    tmpShipLoad.y = 'seller'
                    tmpShipLoad.r = '1'
                    break;
            }

            vm.postItem.M_SHIPLOAD = tmpShipLoad.m;
            // vm.postItem.R_SHIPLOAD = tmpShipLoad.r;
            // vm.postItem.Y_SHIPLOAD = tmpShipLoad.y;            
        },
        /**
         * 共通ステータス設定から、各サイト用ステータスコードに変換、Entityにセットする
         */
        setStatus() {
            let vm = this;
            var tmpStatus = {};
            switch (vm.tmpStatus) {
                case '1':
                    tmpStatus.y = 'new'
                    tmpStatus.r = '5'
                    break;
                case '2':
                    tmpStatus.y = 'used10'
                    tmpStatus.r = '4'
                    break;
                case '3':
                    tmpStatus.y = 'used20'
                    tmpStatus.r = '6'
                    break;
                case '4':
                    tmpStatus.y = 'used40'
                    tmpStatus.r = '3'
                    break;
                case '5':
                    tmpStatus.y = 'used60'
                    tmpStatus.r = '2'
                    break;
                case '6':
                    tmpStatus.y = 'used80'
                    tmpStatus.r = '1'
                    break;
            }
            vm.postItem.M_STATUS = vm.tmpStatus;
            // vm.postItem.R_STATUS = tmpStatus.r;
            // vm.postItem.Y_STATUS = tmpStatus.y;
        },
        paginateClickCallback(pageNum) {
            this.currentPage = Number(pageNum);
        },
        inputFilter(e) {
            let vm = this;
            if (vm.now_input == e) return;
            else vm.now_input = e;
            if (e == null) {
                vm.tmpBrandList = [{ CODE_NAME: "ブランド名を入力してください", CODE_ID: 0 }];
            }
            else {
                for (var i = 0; i < vm.MBrandList.length; i++) {
                    if (vm.MBrandList[i].CODE_ID == e) {
                        vm.tmpBrandList = [vm.MBrandList[i]];
                        return;
                    }
                }
            }
        },
        selectFilter(options, serch) {
            let vm = this;
            if (!serch) {
                return options.filter(x => {
                    return false;
                });
            }
            options = vm.MBrandList;
            return options.filter(x => {
                return x.CODE_NAME.indexOf(serch) != -1;
            });
        },
        /**
         * 商品情報取得
         */
        getSiteInfo() {
            let vm = this;
            otherSiteRepsitory.methods.post({ url: vm.otherSite })
                .then(res => {
                    var data = res.data;
                    if (vm.otherSite.startsWith('https://drive.google.com/')) {
                        for (var img of data.imgs) {
                            if (vm.tmpFiles > 10) return;
                            vm.tmpFiles.push(img);
                        }
                    } else {
                        if (vm.otherSite.startsWith('https://www.amazon.co.jp/')) {
                            vm.postItem.ITEM_PRICE = data.price;

                        } else if (vm.otherSite.startsWith('https://www.sakuradk2.com/')) {
                            vm.postItem.PURCHASE_PRICE = data.price;
                        }
                        vm.postItem.ITEM_CONTENT = data.item_comment.replaceAll('\\n', '\n');
                        //vm.postItem.ITEM_TITLE = data.title;
                        //vm.postItem.ITEM_TITLE2 = data.title;
                        //vm.postItem.ITEM_TITLE3 = data.title;
                        for (var img of data.imgs) {
                            if (vm.tmpFiles > 10) return;
                            vm.tmpFiles.push(img);
                        }
                    }
                    this.$swal(
                        '情報取得が完了しました',
                        '',
                        'success'
                    )
                }).catch(err => {
                    this.$swal(
                        '情報取得に失敗しました',
                        'URLを確認し、再度やり直してください。',
                        'error'
                    )
                })
        },
        /**
         * 初期表示値を設定します。
         */
        init() {
            let vm = this;
            vm.ITEM_ID = vm.$route.params.id;
            if (vm.ITEM_ID != 0) {
                var userInfo = vm.$functions.getSStorage('userInfo');
                var itemId = `${userInfo.USER_ID}_${vm.ITEM_ID}`;

                itemRepository.methods.getOne(itemId)
                    .then(res => {
                        vm.postItem = res.data[0];
                        vm.tmpShipsource = vm.postItem.M_SHIPSOURCE;
                        vm.tmpShipSchedule = vm.postItem.M_SHIPSCHEDULE;
                        vm.tmpShipload = vm.postItem.M_SHIPLOAD;
                        vm.tmpStatus = vm.postItem.M_STATUS;
                        for (var i = 1; i <= 10; i++) {
                            if (eval(`vm.postItem.ITEM_IMG${i}`)) {
                                vm.tmpFiles.push(eval(`vm.postItem.ITEM_IMG${i}`));
                            }
                        }
                        if (vm.postItem.M_CATEGORY != null) {
                            var mCategorys = vm.postItem.M_CATEGORY.split(',');
                            for (var i = 0; i < mCategorys.length - 1; i++) {
                                vm.mCategoryList.child[i].parentId = mCategorys[i];
                                vm.getChildCategory('n', 'mCategoryList', i)
                                if (i == mCategorys.length - 2) {
                                    vm.MercarSizeCheck(vm.mCategoryList.child[i].parentId);
                                    vm.MercarBrandCheck(vm.mCategoryList.child[i].parentId);
                                }
                            }

                        }

                        // if(vm.postItem.R_CATEGORY != null){
                        //     var rCategorys = vm.postItem.R_CATEGORY.split(',');
                        //     for(var i=0; i< rCategorys.length-1; i++){
                        //         vm.rCategoryList.child[i].parentId = rCategorys[i];
                        //         vm.getChildCategory('r', 'rCategoryList',i);
                        //         if(i == rCategorys.length-2) vm.RakumaSizeCheck(vm.rCategoryList.child[i].parentId);
                        //     }
                        // }
                        // if(vm.postItem.Y_CATEGORY != null){
                        //     var yCategorys = vm.postItem.Y_CATEGORY.split(',');
                        //     for(var i=0; i< yCategorys.length-1; i++){
                        //         vm.yCategoryList.child[i].parentId = yCategorys[i];
                        //         vm.getChildCategory('y', 'yCategoryList',i)
                        //     }
                        // }

                        // if(vm.postItem.Y_QUANTITY == null)vm.postItem.Y_QUANTITY = 1;
                        // if(vm.postItem.Y_OPTIONS != null)vm.tmpYOptions = vm.postItem.Y_OPTIONS.split(',');
                        // if(vm.postItem.SUSPEND_FLG == null)vm.postItem.SUSPEND_FLG = 1;
                        if (vm.postItem.ROOP_IMG != null) vm.tmpRoopImg = vm.postItem.ROOP_IMG.split(',').filter(Boolean);
                        var index = vm.tmpRoopImg.indexOf('0');
                        if (index != -1) {
                            vm.tmpRoopImg.splice(index, 1)
                        }
                        if (vm.tmpRoopImg.length > 0) {
                            vm.tmpRoopImg = this.tmpRoopImg.filter((element, index) => this.tmpRoopImg.indexOf(element) == index).sort();
                        }

                    }).catch(err => {
                        console.log(err);
                    })
                var item_detail = {
                    'type': 'get_mercari_item_detail',
                    'ITEM_ID': itemId
                }
                cApiRepsitory.methods.post(item_detail).then(res => {
                    if (res.data.length != 0) {
                        vm.m_postItem = res.data[0];
                        vm.m_postItem.MULTIPLE_SELL = 2;
                        vm.m_postItem.type = 'mercari_item_detail';
                        if (vm.m_postItem.M_BRAND) {
                            vm.tmpBrandList = [vm.MBrandList.find(x => x.CODE_ID == vm.m_postItem.M_BRAND)];
                        }
                    }
                })
            }
        },
        test(base64) {
            let vm = this;
            vm.showModal = true;
            vm.tmpBase64 = base64;
            console.log(base64);
        },
        test2() {
            console.log('aaa');
        },
        /**
         * エラーアラートを表示します
         * @param {string}} msg エラーアラートに表示するメッセージ
         */
        ngAlert(msg) {
            this.$swal(
                '',
                msg,
                'error'
            )
        }
    },
    computed: {
        getPaginateCount: function () {
            return Math.ceil(this.tmpBrandList.length / this.perPage);
        },
        getItems() {
            let vm = this;
            if (vm.m_postItem.M_BRAND) {
                vm.tmpBrandList = [vm.MBrandList.find(x => x.CODE_ID == vm.m_postItem.M_BRAND)];
                return;
            }
            vm.tmpBrandList = vm.MBrandList
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            return this.tmpBrandList.slice(start, end);
        }
    },
    created: function () {
        let vm = this;
        for (var i = 1; i <= 7; i++) {
            // vm.YEndDayList.push({
            //     CODE_ID:i,
            //     CODE_NAME: `出品から${i}日後`
            // })
        }

        codeRepository.methods.GetCode()
            .then((data) => {
                vm.baseCode = data.data;
                //商品状態選択リスト
                vm.statusList = vm.GetCode("m", "status");
                vm.shiploadList = vm.GetCode("m", "shipLoad");
                vm.shipsorceList = vm.GetCode("m", "shipSource");
                vm.shipScheduleList = vm.GetCode("m", "shipSchedule");
                // vm.MSizeList            = vm.GetCode("m", "size");
                vm.MShipMethodList = vm.GetCode("m", "shipMethod");
                vm.MSizeList1 = vm.GetCode("m", "size1");
                vm.MSizeList2 = vm.GetCode("m", "size2");
                vm.MSizeList3 = vm.GetCode("m", "size3");
                vm.MSizeList4 = vm.GetCode("m", "size4");
                vm.MSizeList5 = vm.GetCode("m", "size5");
                vm.MSizeList6 = vm.GetCode("m", "size6");
                vm.MSizeList7 = vm.GetCode("m", "size7");
                vm.MSizeList8 = vm.GetCode("m", "size8");
                vm.MSizeList9 = vm.GetCode("m", "size9");
                vm.MSizeList10 = vm.GetCode("m", "size10");
                vm.MSizeList11 = vm.GetCode("m", "size11");
                vm.MSizeList12 = vm.GetCode("m", "size12");
                vm.MBrandList = vm.GetCode("m", "brand");
            });

        categoryRepository.methods.GetCategories()
            .then((data) => {
                vm.baseCategories = data.data;
                vm.mCategoryList.child[0].parent = vm.GetCategories("n", "0");
                // vm.rCategoryList.child[0].parent = vm.GetCategories("r", "0");
                // vm.yCategoryList.child[0].parent = vm.GetCategories("y", "0");
                vm.init();

            });




    },
    validations: {
        //商品状態
        tmpStatus: {
            required
        },
        //送料負担
        tmpShipload: {
            required
        },
        //発送元
        tmpShipsource: {
            required
        },
        //発送日数
        tmpShipSchedule: {
            required
        },
        mCategoryList: {
            child: {
                $each: {
                    parentId: {
                        required
                    }
                }
            }
        },
        rCategoryList: {
            child: {
                $each: {
                    parentId: {
                        required
                    }
                }
            }
        },
        yCategoryList: {
            child: {
                $each: {
                    parentId: {
                        required
                    }
                }
            }
        },
        postItem: {
            //商品説明
            ITEM_CONTENT: {
                required,
                maxLength: maxLength(1000)
            },
            //商品価格
            ITEM_PRICE: {
                required,
                minValue: minValue(0),
                err: (val) => check.HankakuSuuzi(val)
            },
            //商品仕入価格
            PURCHASE_PRICE: {
                minValue: minValue(0),
                err: (val) => check.HankakuSuuzi(val)
            },
            //在庫数
            STOCK_QUANITY: {
                required,
                minValue: minValue(0),
                err: (val) => check.HankakuSuuzi(val)
            },
            //商品名
            ITEM_TITLE: {
                required,
                maxLength: maxLength(40)
            },
            //商品名2
            ITEM_TITLE2: {
                maxLength: maxLength(40)
            },
            //商品名3
            ITEM_TITLE3: {
                maxLength: maxLength(40)
            },
            //値引額
            DISCOUNT_PRICE: {
                minValue: minValue(0),
                err: (val) => check.HankakuSuuzi(val)
            },
            //値引き回数
            DISCOUNT_NUM: {
                //between: between(0, 3),
                //err: (val) => check.HankakuSuuzi(val)
            },
            Y_CATEGORY: {
                required
            },
            Y_QUANTITY: {
                required
            },
            Y_SALESMODE: {
                required
            },
            Y_STARTPRICE: {
                required
            },
            Y_ENDDAY: {
                required
            },
            Y_ENDTIME: {
                required
            },
            Y_CATEGORYORDER: {
                required
            },
            M_CATEGORY: {
                required
            },
            M_SHIPMETHOD: {
                required
            },
            M_SIZE: {
                required
            },
            R_CATEGORY: {
                required
            },
            R_SHIPMETHOD: {
                required
            },
            R_SIZE: {
                required
            }
        }
    }
}
</script>
<style>
.childImgBox.setImgBox {
    width: 110px;
}
</style>